import React from "react";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import CardSection from "./CardSection";

const breadCrumbs: BreadCrumbItem[] = [
  {
    path: "/",
    label: "Inicio",
  },
  {
    path: "/propietarios_mascotas",
    label: "Propietarios y Mascotas",
    isActive: true,
  },
];

function PropietariosYMascotas() {
  return (
    <Page
      title="Propietarios y Mascotas"
      description="Visualización, creación y edición de propietarios y mascotas."
      breadCrumbs={breadCrumbs}
    >
      <CardSection />
    </Page>
  );
}

export default PropietariosYMascotas;
